import { useMutation, useQueryClient } from 'react-query';

import { deleteDigestReport as reportDelete } from 'api/digestReports/deleteDigestReport';

const useDeleteDigestReport = () => {
  const queryClient = useQueryClient();

  const {
    isSuccess,
    mutate: deleteDigestReport,
    isLoading,
  } = useMutation(reportDelete, {
    onSuccess: () => {
      queryClient.invalidateQueries('digestReportsListPost');
    },
  });

  return {
    isSuccess,
    deleteDigestReport,
    isLoading,
  };
};

export default useDeleteDigestReport;
